import { ProgressBar } from "primereact/progressbar";
import "./WorklogCalendar.css";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "underscore";
import { dateConvert, MuiCss, MuiTextInputStyle } from "../../../utils/Helper";
import { useCommon } from "../../../Hooks/Common/useCommon";
import { DataTable } from "primereact/datatable";
import { useLogwork } from "../../../Hooks/Features/Dashboard/useLogwork";
import DatePicker from "react-multi-date-picker";
import { Column } from "primereact/column";
import CommanDialog from "../../CommonCompo/CommanDialog/CommanDialog";
import PanelHeaderTemplate from "../../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { MultiSelect } from "primereact/multiselect";
import { SkeletonContainer, SkeletonDataTable } from "../../Loader/Loader";
import { Dialog } from "primereact/dialog";
const filter = createFilterOptions();

function Logwork({ loader, pendingLogDate, closePopup, onSave, addLogData, handleDateSelected, editFlag, date, timesheetData, setFilterValue, filterValue, isMyBucket, clickedRowTaskId }) {

    const { checkPermission } = useCommon();
    const [editLogFlag, setEditLogFlag] = useState(false);
    const [rowDataToDelete, setRowDataToDelete] = useState({});
    const { selectedEmployee, userCode, logData, dateSelected, setDateSelected, timeDropdown, timeSelected, handleTimeSpent, progressValue, options, optionSelected, setOptionSelected, handleTaskSelect, selectFromTask, handleSaveLog, handleTimeSelected, handleReset, handleValidation, error, setError, validateWordCount, logsValue, setLogsValue, loaderButton, setOptions, navigateDate, setNavigateDate, tagRef, confirmationPopup, setConfirmationPopup, handleDeleteLogs, getProjectModule, sidebarCollapsed, setSidebarCollapsed, setEditLogData, importDataPopup, setImportDataPopup, importPmoData, spin, showStatusPopup, setShowStatusPopup, handleStatusChange, enabelPopup, setEnabelpopup, extensionForm, setExtensionForm, saveExtensions, } = useLogwork({ closePopup, onSave, addLogData, handleDateSelected, editFlag, isMyBucket, clickedRowTaskId });
    const [columns] = useState([
        {
            field: "day_date",
            headerName: "Date",
            width: 6
        },
        {
            field: "project_name",
            headerName: "Project Name",
            width: 10
        },
        {
            field: "client_name",
            headerName: "Client Name",
            width: 9
        },
        {
            field: "project_module_name",
            headerName: "Project Module",
            width: 9
        },
        {
            field: "issue_key",
            headerName: "Key",
            width: 8
        },
        {
            field: "issue_type_name",
            headerName: "Issue Type",
            width: 10
        },
        {
            field: "comment",
            headerName: "Comment",
            width: 35
        },
        {
            field: "log_time",
            headerName: "Log Time",
            width: 10
        },
        {
            field: "timeSpent",
            headerName: "Time Spent",
            width: 10
        },
        {
            field: "action",
            headerName: "Action",
            width: 4
        },
    ])

    useEffect(() => {
        setDateSelected(date || new Date());
        // eslint-disable-next-line
    }, [date])

    const issuesTemplate = (option) => {
        return (
            <div className="d-flex gap-2 align-items-center">
                <span style={{ fontWeight: "bold" }}>{option.issue_key}</span>
                <span
                    className="rounded-pill d-flex justify-content-center px-2" style={{ background: "#d8d5d5" }}>
                    {option?.status_name}
                </span>
                <span> {option.issue_summary.length > 90 ? `${option.issue_summary.slice(0, 90)}...` : option.issue_summary}</span>
            </div>
        );
    }

    const selectedIssuesTemplate = (option, props) => {
        if (option) {
            return (
                <div className="d-flex gap-2 align-items-center">
                    <span style={{ fontWeight: "bold" }}>{option.issue_key}</span>
                    <span
                        className="rounded-pill d-flex justify-content-center px-2 py-1" style={{ background: "#d8d5d5" }}>
                        {option?.status_name}
                    </span>
                    <span> {option.issue_summary.length > 90 ? `${option.issue_summary.slice(0, 90)}...` : option.issue_summary}</span>
                </div>
            );
        }
        return <div>{props.placeholder}</div>
    }

    return (
        <div className="log-work" style={{ height: "100%" }}>

            <div className="d-flex flex-wrap w100" style={{ height: "auto" }}>
                {
                    (isMyBucket || (selectedEmployee?.user_code) === parseInt(userCode)) &&
                    <div
                        className={`log-sidebar mb-3 border-end bg-white d-flex flex-column ${sidebarCollapsed ? "collapsed" : ""}  `}
                    >
                        <div
                            className="sidebar-header d-flex justify-content-between align-items-center bg-light border-bottom p-1"
                            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                        >
                            {!sidebarCollapsed && <span>Log Work Entry</span>}
                            <FontAwesomeIcon icon={`fa-solid ${sidebarCollapsed ? "fa-angle-right" : "fa-angle-left"
                                }`} />
                        </div>
                        {
                            !sidebarCollapsed &&
                            <>
                                <div className="add-log-popup position-relative" style={{ overflowX: "hidden" }}
                                >
                                    <div className=" ">
                                        {
                                            options.tasks?.length > 0 && <div className="w100">
                                                <label>Task List</label>
                                                <Dropdown showClear placeholder="Task" options={options.tasks}
                                                    value={optionSelected.tasks} optionLabel="issue_key" className="input-dd" onChange={(e) => handleTaskSelect(e.target.value)} filter filterInputAutoFocus itemTemplate={issuesTemplate} valueTemplate={selectedIssuesTemplate}
                                                    disabled={isMyBucket && selectFromTask} />
                                            </div>
                                        }
                                        <div className="w100">
                                            <label>Project *</label>
                                            <Dropdown placeholder="" options={options.projects} value={optionSelected.projects} optionLabel="project_name" className="input-dd" disabled={selectFromTask} onChange={(e) => {
                                                setOptionSelected((prev) => ({ ...prev, projects: e.target.value })); setOptions((prevState) => ({ ...prevState, is_disabled: false }))
                                            }} filter filterInputAutoFocus />
                                        </div>
                                        <div className="w100">
                                            <label>Client *</label>
                                            <Dropdown placeholder="" options={options.clients} value={optionSelected.client} optionLabel="client_name" className="input-dd" disabled={selectFromTask || options.clients?.length === 1} onChange={(e) => {
                                                setOptionSelected((prev) => ({ ...prev, client: e.target.value })); setOptions((prevState) => ({ ...prevState, is_disabled: false }))
                                            }} filter filterInputAutoFocus />
                                        </div>
                                        {
                                            !_.isEmpty(options?.project_module) && <div className="w100">
                                                <label>Project Module</label>
                                                <Dropdown placeholder="" options={options.project_module} value={optionSelected.project_module} optionLabel="option_value" className="input-dd" disabled={selectFromTask} onChange={(e) => {
                                                    setOptionSelected((prev) => ({ ...prev, project_module: e.target.value })); setOptions((prevState) => ({ ...prevState, is_disabled: false }))
                                                }} filter filterInputAutoFocus />
                                            </div>
                                        }
                                        <div className="w100 d-flex gap-2">
                                            <div className="w50">
                                                <label>Worklog Type *</label>
                                                <Dropdown placeholder="" options={options.types} value={optionSelected.types} optionLabel="issue_type_name" className="input-dd" disabled={selectFromTask} onChange={(e) => setOptionSelected((prev) => ({ ...prev, types: e.target.value }))} filter filterInputAutoFocus />
                                            </div>
                                            <div className="w50">
                                                <label>Time Spent * (5h 30m)</label>
                                                <input type='text' className="w100 input-dd" value={logData?.entered_hours_string} onChange={(e) => { handleTimeSpent(e.target.value); setError("") }} placeholder="" onBlur={(e) => { handleValidation(e.target.value, setError) }} />
                                                {error && (
                                                    <p className="text-danger text-left font-weight-bold" style={{ fontSize: "small" }}>
                                                        {error}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="w100">
                                            <div className=" d-flex gap-2">
                                                <div className="input-calender w50">
                                                    <label>Date</label>
                                                    <Calendar value={dateSelected || new Date()} onChange={(e) => { setDateSelected(e.target.value); if (handleDateSelected !== undefined && _.isEmpty(optionSelected.projects) && logsValue?.length === 0) { handleReset(); } }} dateFormat='dd-mm-yy'   placeholder="Log Date" />
                                                </div>
                                                <div className="w50">
                                                    <label>Log Time *</label>
                                                    <Autocomplete
                                                        value={timeSelected}
                                                        name="last_name"
                                                        onChange={(event, newValue) => handleTimeSelected(newValue)}
                                                        filterOptions={(options, params) => {
                                                            const filtered = filter(options, params);
                                                            const { inputValue } = params;
                                                            if (inputValue !== '' && !options.some(option => inputValue === option.label)) {
                                                                filtered.push({ value: inputValue, label: `${inputValue}` });
                                                            }
                                                            return filtered;
                                                        }}
                                                        options={timeDropdown}
                                                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || '')}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.value}>
                                                                {option.label}
                                                            </li>
                                                        )}
                                                        sx={MuiCss}
                                                        freeSolo
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                // label="Log Time"
                                                                className="input"

                                                                onBlur={(e) => { if (timeSelected?.label?.toLowerCase() !== e?.target?.value?.toLowerCase()) { handleTimeSelected(e?.target?.value); } }}
                                                                sx={MuiTextInputStyle}
                                                            />
                                                        )}
                                                        placeholder="Select time"
                                                    />

                                                </div>
                                            </div>
                                            <div className="w100 mt-2">
                                                <div className="d-flex add-log-child">
                                                    <ProgressBar value={progressValue} className='blue-progress' style={{ width: "100%" }} />
                                                    <ProgressBar value={100} className='red-progress' style={{ width: `calc(${progressValue}% - 100%)` }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w100">
                                            <label>Work description *</label>
                                            <textarea value={logsValue} onChange={(e) => { setLogsValue(e.target.value); }} rows={6} className="w100" placeholder="Write here..." style={{ resize: "none" }} />
                                        </div>

                                        <div className="w100">
                                            <div>{validateWordCount(logsValue) > (optionSelected?.types?.min_log_words || 5) ? "" : `${validateWordCount(logsValue)}/${optionSelected?.types?.min_log_words || 5} words`}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right d-flex justify-content-between align-items-center position-sticky" >
                                    <div className="w50">
                                        <div ref={() => checkPermission("Worklog", tagRef)}>
                                            <div ref={tagRef} id='{"tabname": "worklog", "data": "add_log_date_navigate_btn"}'>
                                                <div className="d-flex gap-1 align-items-center" >
                                                    <input type="checkbox" name="log-navigate" id="log-navigate" value={navigateDate} onChange={() => setNavigateDate(navigateDate ? false : true)} checked={navigateDate} />
                                                    <label htmlFor="log-navigate">Navigate to next date</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end w50">
                                        <button onClick={() => { handleReset(); if (!_.isEmpty(addLogData)) { closePopup(); setEditLogData({}) } }} className="btn btn-default"><FontAwesomeIcon icon="fa-solid fa-xmark" /> Reset</button>
                                        <div>
                                            {loaderButton ?
                                                <button className="btn btn-primary" style={{ width: "75px" }}>
                                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                                        <span className="sr-only"></span>
                                                    </div>
                                                </button> :
                                                <button className="btn btn-primary w100" onClick={() => { handleSaveLog(); }}> <FontAwesomeIcon icon="fa-solid fa-check" />  Submit</button>
                                            }
                                        </div>
                                    </div>
                                </div></>
                        }
                    </div>
                }
                <div className="log-details flex-fill w75 px-1 overflow-auto" >
                    {
                        (selectedEmployee?.user_code) === parseInt(userCode) && <header className="w100 mb-2 text-white" style={{ background: "#e3e3e3", height: "auto" }}>
                            <div className="d-flex gap-2 overflow-auto" style={{ scrollbarWidth: "none" }}>
                                <p className="text-dark align-self-center px-1 fw-semibold" style={{ fontSize: "medium" }} >Pending Log:</p>
                                {
                                    pendingLogDate?.map((val) => {
                                        return <div className="m-2">
                                            <div class={`date-pill badge-count position-relative ${new Date(val?.startdate)?.getDate() === dateSelected?.getDate() && "active"}`} onClick={() => { handleDateSelected(val?.startdate, true); handleReset() }}>{new Date(val?.startdate)?.getDate()}
                                                {
                                                    val.loginfo > 0 && <div className='count'>{val.loginfo}</div>
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </header>
                    }
                    <div className="w100" style={{ display: "flex", flexDirection: "column", height: "85%", }}>
                        <div className='row m-0'>
                            <div className="col-md-2 col-6">
                                <MultiSelect
                                    placeholder='Project'
                                    options={options.projects}
                                    value={filterValue?.projects}
                                    onChange={(e) => { setFilterValue((prev) => ({ ...prev, projects: e.value, isChange: true })); }}
                                    optionLabel='project_name'
                                    filter filterInputAutoFocus
                                    onHide={() => { if (filterValue?.isChange) { getProjectModule(filterValue?.projects); handleDateSelected(); setFilterValue((prev) => ({ ...prev, isChange: false })) } }}
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'projects', options.projects, (val) => setFilterValue((prev) => ({ ...prev, projects: val, isChange: true })), () => { })}
                                />
                            </div>
                            <div className="col-md-2 col-6">
                                <MultiSelect
                                    placeholder='Project Module'
                                    options={options?.filter_project_module}
                                    value={filterValue?.project_module}
                                    onChange={(e) => { setFilterValue((prev) => ({ ...prev, project_module: e.value, isChange: true })); }}
                                    optionLabel='option_value'
                                    filter filterInputAutoFocus
                                    onHide={() => { if (filterValue?.isChange) { handleDateSelected(); setFilterValue((prev) => ({ ...prev, isChange: false })) } }}
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'project_module', options.project_module, (val) => setFilterValue((prev) => ({ ...prev, project_module: val, isChange: true })), () => { })}
                                />
                            </div>
                            <div className="col-md-2 col-6">
                                <MultiSelect
                                    placeholder='Issue Type'
                                    options={options?.issueType}
                                    value={filterValue?.issueType}
                                    onChange={(e) => {
                                        setFilterValue((prev) => ({ ...prev, issueType: e.value, isChange: true }));
                                    }}
                                    optionLabel='issue_type_name'
                                    filter filterInputAutoFocus
                                    onHide={() => { if (filterValue?.isChange) { handleDateSelected(); setFilterValue((prev) => ({ ...prev, isChange: false })) } }}
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'issueType', options.issueType, (val) => setFilterValue((prev) => ({ ...prev, issueType: val, isChange: true })), () => { })}
                                />
                            </div>
                            <div className="col-md-2 col-6">
                                <DatePicker portal zIndex={99999}
                                    value={filterValue?.hoveredRange}
                                    onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValue((prev) => ({ ...prev, hoveredRange: e, isChange: true }));
                                            }
                                        }}
                                    range
                                    rangeHover
                                    placeholder="Select Date"
                                    onClose={() => { if (filterValue?.isChange) { handleDateSelected(); setFilterValue((prev) => ({ ...prev, isChange: false })) } }}
                                />

                            </div>
                            <div className="col-md-4 col-5 text-right">
                                <div className="d-flex gap-2 justify-content-end align-items-left">
                                    <div title='Refresh'>
                                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" className='widgets-icon' onClick={() => { handleDateSelected() }} />
                                    </div>
                                    <div ref={() => checkPermission("Worklog", tagRef)}>
                                        <button onClick={() => setImportDataPopup(true)} ref={tagRef} id='{"tabname": "worklog", "data": "import_data_btn"}'>PMO Data Import</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1, overflow: "auto" }}>
                            {
                                loader ? <SkeletonDataTable numSkeletons={15} /> :
                                    <DataTable
                                        tableStyle={{
                                            minWidth: '50%',
                                        }}
                                        value={timesheetData?.log_details}
                                        rowGroupMode="rowspan"
                                        groupRowsBy="day_date"
                                        sortMode="single"
                                        sortField="day_date"
                                        sortOrder={1}
                                        scrollable
                                        scrollHeight="100%"
                                        className='mt-1 mx-1'
                                    >
                                        {columns.map((col, i) => (
                                            <Column
                                                key={col.field}
                                                field={col.field}
                                                header={col.headerName}
                                                style={{ width: col?.width ? col.width + "%" : "auto", minWidth: col?.width ? col.width + "%" : "auto" }}
                                                hidden={col.field === "action" && !isMyBucket && !((parseInt(selectedEmployee?.user_code) === parseInt(userCode)))}
                                                body={col.field === "issue_key" ? (rowData) => {
                                                    return <a href={rowData.issue_url} target='_blank' rel="noreferrer noopener">{rowData.issue_key}</a>
                                                } : (col.field === "day_date") ? (rowData) => {
                                                    return <div>{dateConvert(rowData?.day_date, "day-mon-year")}</div>
                                                }
                                                    : (col.field === "action" ? (rowData) => {
                                                        return <div className='d-flex justify-content-evenly w100'>
                                                            <FontAwesomeIcon icon="fa-solid fa-pen" className='icons text-primary' onClick={() => { setEditLogFlag(!editLogFlag); setEditLogData(rowData); }} /> <FontAwesomeIcon icon="fa-solid fa-trash" className='icons text-primary' onClick={() => { handleDeleteLogs(rowData, false); setRowDataToDelete(rowData) }} />
                                                        </div>
                                                    } : (col.field === "comment" ? (rowData) => {
                                                        return <span style={{ whiteSpace: "pre-wrap" }}>{`${rowData.comment}`}</span>
                                                    } : ""))}
                                            />
                                        ))}
                                    </DataTable>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Dialog visible={showStatusPopup?.show} draggable={false} onHide={() => { setShowStatusPopup({ show: false }); }} className="modal-xsmall" header={`Update Task Status (${showStatusPopup?.rowdata?.issue_key})`}>
                <div>
                    <div className="notes my-2">
                        Please update its status to "In Progress" before filling logs.
                    </div>

                    {showStatusPopup?.loader ? <div style={{ height: "30px" }}><SkeletonContainer /></div> :
                        <Dropdown className="tast-list-dd my-2 " options={showStatusPopup?.statusList || []} optionLabel="name" value={showStatusPopup?.selectedStatus} onChange={(e) => { handleStatusChange(e.target.value) }} />
                    }
                </div>
            </Dialog>
            <div>
                <CommanDialog visible={confirmationPopup} handleClose={() => setConfirmationPopup(false)} handleFun={() => { handleDeleteLogs(rowDataToDelete, true); }} message="Are you sure you want to delete the log?" />
            </div>
            <Dialog visible={importDataPopup} modal onHide={() => {
                setImportDataPopup(false);
                setFilterValue((prev) => ({ ...prev, importDate: null }))
            }}
                className='modal-xsmall' style={{ width: "150px" }}
                draggable={false} header={() => <div>Import Data</div>}>
                <div className=" d-flex justify-content-center">
                    <DatePicker portal zIndex={99999}
                        value={filterValue?.importDate}
                        onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValue((prev) => ({ ...prev, importDate: e, isChange: true }));
                                            }
                                        }}
                        range
                        rangeHover
                        placeholder="Select Date"
                        className="w100"
                        onClose={() => { if (filterValue?.isChange) { setFilterValue((prev) => ({ ...prev, isChange: false })) } }}
                    />
                </div>
                <div className="mt-2 d-flex justify-content-center">
                    {
                        spin ? <button className="button btn-primary w25">
                            <div className="spinner-border" role="Import" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button>
                            : <button onClick={() => importPmoData(filterValue, setFilterValue)}>Import</button>
                    }
                </div>
            </Dialog>
        </div>
    )
}

export default Logwork